import useLocalStorage from "@hooks/useLocalStorage"
import useRouter from "@hooks/useRouter"
import useSlugExtractor from "@hooks/useSlugExtractor"

import { faIcon } from "@utils/faIcon"

import { ExtraTouchArea } from "@particles/index"

import { IconButton, ScrollableContainer } from "@atoms/index"

import { NavTopBar } from "@organisms/index"

import SettingsNavigation from "@pages/Settings/components/SettingsNavigation/SettingsNavigation"

import { HOME_ROUTE } from "@routes/home"

import { SETTINGS_PREVIOUS_PAGE } from "@constants/storage"

import styles from "./SettingsNavSidebar.module.scss"

function SettingsNavSidebar() {
    const [previousPage] = useLocalStorage<string | null>(SETTINGS_PREVIOUS_PAGE, null)

    const router = useRouter()

    const [homeRoute] = useSlugExtractor([HOME_ROUTE])

    const onBackButtonClick = () => {
        router.push(previousPage ?? homeRoute)
    }

    return (
        <nav className={styles.base}>
            <NavTopBar.Header>
                <NavTopBar.NavTopBarHeaderStart>
                    <ExtraTouchArea extraTouchArea={6}>
                        <IconButton
                            size="lg"
                            variant="ghost"
                            isTabbable={true}
                            icon={faIcon({ name: "arrow-left", style: "regular" })}
                            onClick={onBackButtonClick}
                            aria-label="Back to previous page"
                            noDebounce={true}
                        />
                    </ExtraTouchArea>
                    <NavTopBar.PageInnerTitle label="Settings" />
                </NavTopBar.NavTopBarHeaderStart>
            </NavTopBar.Header>
            <ScrollableContainer className={styles.settingsNavigation}>
                <SettingsNavigation />
            </ScrollableContainer>
        </nav>
    )
}

export default SettingsNavSidebar
